export default function NvidiaChips() {
  const resize = 1.7;
  const relativeScales = [
    {scale: 1, label: 'H100', flops: ' (1 x 10^15 FLOP/s)', dieSize: 1/resize}, 
    {scale: 2.5, label: 'B200', flops: ' (2.5 x 10^15 FLOP/s)', dieSize: 2/resize}, 
    {scale: 6, label: 'R200*', flops: ' (6 x 10^15 FLOP/s)', dieSize: 2*1.2/resize}
  ];
  const boxSize = .1;

  return (
    <div className="flex flex-col gap-6 mt-8 mb-8 w-full max-w-[690px]">
      {/* Legend */}
      <div className="text-xs font-sans text-center mb-2">
        <span className="inline-flex items-center mr-4">
          <div className="w-3 h-3 bg-gray-700 rounded-[1px] mr-1"></div>
          Scaled to performance
        </span>
        <span className="inline-flex items-center">
          <div className="w-3 h-3 rounded-full bg-[rgba(20,103,20,0.2)] mr-1"></div>
          Scaled to die size
        </span>
      </div>
      
      {/* Always row layout with minimum width to prevent stacking */}
      <div className="flex flex-row justify-between gap-10 h-full w-full relative pt-5" style={{ minHeight: "200px" }}>
        {relativeScales.map((item, index) => {
          // Calculate grid dimensions to create a square layout
          const gridDimension = Math.floor(Math.sqrt(item.scale / boxSize));
          const remainder = item.scale % boxSize;
          
          return (
            <div key={item.scale} className="flex-1 flex flex-col">
              {/* Center container - this will contain both the circle and boxes */}
              <div className="flex-1 flex items-center justify-center relative">
                {/* Circle backdrop */}
                <div 
                  className="absolute rounded-full bg-[rgba(20,103,20,0.15)]" 
                  style={{ 
                    width: `${80 * Math.sqrt(item.dieSize)}px`, 
                    height: `${80 * Math.sqrt(item.dieSize)}px`
                  }}
                ></div>
                
                {/* Box rendering */}
                <div className="z-10">
                  <div 
                    className="grid gap-[1.5px]"
                    style={{ 
                      gridTemplateColumns: `repeat(${gridDimension}, 8px)`,
                      gridTemplateRows: `repeat(${gridDimension}, 8px)`
                    }}
                  >
                    {Array.from({ length: gridDimension * gridDimension }).map((_, i) => (
                      <div key={i} className="hover:bg-[var(--accent)] transition-bg duration-500 w-[8px] h-[8px] bg-gray-700 rounded-[1px]" />
                    ))}
                  </div>
                  
                  {/* Partial boxes */}
                  {remainder > 0 && (
                    <div className="flex gap-[1.5px] justify-center mt-1">
                      {Array.from({ length: remainder }).map((_, i) => (
                        <div key={i} className="hover:bg-[var(--accent)] transition-bg duration-500 w-[4px] h-[4px] bg-gray-500 rounded-xs" />
                      ))}
                    </div>
                  )}
                </div>
              </div>
              
              {/* Label - separate from the flex container */}
              <div className="text-xs font-sans text-center mt-4">
                {item.label} <br />
                {item.flops}
              </div>
            </div>
          );
        })}
      </div>

      <div className="w-full mt-0 relative">
      {/* Horizontal line */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gray-400"></div>
      
      {/* Tick marks and year labels with adjusted positioning */}
      <div className="flex flex-row justify-between w-full px-2">
          {/* 2023 tick and label - shifted left */}
          <div className="flex flex-col items-center" style={{ marginLeft: "12%" }}>
          <div className="h-3 w-[1px] bg-gray-400"></div>
          <div className="text-xs font-sans text-center mt-1">2023</div>
          </div>
          
          {/* 2025 tick and label */}
          <div className="flex flex-col items-center">
          <div className="h-3 w-[1px] bg-gray-400"></div>
          <div className="text-xs font-sans text-center mt-1">2025</div>
          </div>
          
          {/* 2027 tick and label - shifted right */}
          <div className="flex flex-col items-center" style={{ marginRight: "12%" }}>
          <div className="h-3 w-[1px] bg-gray-400"></div>
          <div className="text-xs font-sans text-center mt-1">2027</div>
          </div>
      </div>
      <div className="text-xs" style={{ marginLeft: "90%" }}>*Expected</div>
      </div>
    </div>
  );
}